import { render, staticRenderFns } from "./ad-underlying-detail-page-header.vue?vue&type=template&id=4de200b2"
import script from "./ad-underlying-detail-page-header.vue?vue&type=script&lang=ts"
export * from "./ad-underlying-detail-page-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports